import { Button as FluentButton } from '@fluentui/react-components';
import React, { forwardRef } from 'react';

import { useClassNames } from './Button.styles';
import type { ButtonProps } from './Button.types';

export const Button = forwardRef<HTMLButtonElement | HTMLAnchorElement | null, ButtonProps>((props, ref) => {
  const { fullWidth = false, disabled = false, className, appearance, ...baseButtonProps } = props;
  const isPrimaryBlue = appearance === 'primaryBlue';
  const classNames = useClassNames(fullWidth, className, isPrimaryBlue, disabled);
  const passedAppearance = isPrimaryBlue ? 'primary' : appearance;

  const hrefProps: Record<string, string> = baseButtonProps.href ? { as: 'a', target: '_blank' } : {};

  return (
    <FluentButton
      {...baseButtonProps}
      {...hrefProps}
      ref={ref}
      appearance={passedAppearance}
      disabled={disabled}
      className={classNames.root}
    />
  );
});

Button.displayName = 'Button';
